<div class="form-group">
    <label class="ui-checkbox">
    <input type="checkbox"
           name="fieldOptions.notvisible" value="{{fieldOptions.notvisibleeditmode}}"
           [(ngModel)]="fieldOptions.notvisibleeditmode"
           (ngModelChange)="dataChangedEvent($event)" class="form-control">
    <span><b>Not visible in Grid edit mode</b></span>
  </label>
</div>